import React, { memo, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQueries } from 'react-query';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useTopPanel from 'hooks/useTopPanel';
import ModalNewFieldMaker from './WarehouseIntegration';

const Target = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);

  const [warehouseQuery] = useQueries([
    {
      queryKey: '/admin/integration/warehouse',
      queryFn: async function () {
        const response = await axiosPrivate.get(`/admin/integration/warehouse`);
        return response.data.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
    },
  ]);

  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('settings.variables.title')}</div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-table-wrapper grid grid-cols-3 gap-3 pt-2 relative h-[calc(100vh-75px)] overflow-y-auto my-scroll'>
        <div className='h-[300px] shadow-lg rounded-lg flex flex-col justify-between border border-gray-300 hover:bg-white hover:shadow-xl transition-all duration-200'>
          <div className='header h-3/4 flex items-center justify-center'>
            <i
              className={`bi bi-house-${
                warehouseQuery?.data?.id ? 'gear' : 'add'
              } text-[70px]`}
            />
          </div>
          <div className='footer h-1/4 overflow-hidden'>
            <Button
              variant='contained'
              className='!w-full !h-full !rounded-t-none'
              color='primary'
              onClick={() => {
                setIsOpenModal(true);
              }}
              startIcon={
                <i
                  className={`bi bi-${
                    warehouseQuery?.data?.id ? 'gear' : 'plus-circle'
                  }`}
                />
              }
            >
              {t(
                `settings.integration.${
                  warehouseQuery?.data?.id ? 'editModal' : 'addModal'
                }.warehouse`
              )}
            </Button>
          </div>
        </div>
      </div>
      {isOpenModal && (
        <ModalNewFieldMaker
          open={isOpenModal}
          setOpen={setIsOpenModal}
          data={warehouseQuery.data}
          refetch={warehouseQuery.refetch}
        />
      )}
    </div>
  );
};

export default memo(Target);
